/**
 * Teksten der fortæller, hvad deltagernavnet blev valideret imod.
 *
 * Navnereglen i cle-compliance-api sammenligner navnet på beviset med
 * `owner_display_name_snapshot` — ejerens navn på uploadtidspunktet, som fryses
 * ved oprettelsen og aldrig opdateres. Skifter advokaten navn i AIKA bagefter,
 * bliver beviset ved med at blive målt mod det gamle navn.
 *
 * Uden den oplysning i skærmbilledet læser en afvisning som en selvmodsigelse:
 * personsiden viser et navn, der matcher beviset, mens valideringen siger det
 * modsatte. Den usynlige tredje værdi er hele årsagen til forvirringen — og den
 * fik i praksis en sagsbehandler til at overskrive deltagernavnet med det gamle
 * navn for at rydde flaget.
 *
 * Returnerer `null`, når der intet er at forklare. Et tomt snapshot er netop det
 * tilfælde, hvor reglen melder "uploaderens navn kunne ikke hentes" frem for et
 * mismatch, og så er der ingen sammenligning at vise.
 */
export const formatComparedWithName = (
  ownerDisplayNameSnapshot: string | null | undefined,
): string | null => {
  const name = ownerDisplayNameSnapshot?.trim();

  return name ? `Sammenlignet med: ${name} (navn ved upload)` : null;
};
